// PGVideoData
import React, { FC } from 'react';
import VideoPlayer from '../../components/VideoPlayer';
import Comma from '../../components/Comma';

import styles from './PGVideo.module.scss';

interface Props {
  PGVideoData: { [key: string]: string };
}
const PGVideo: FC<Props> = (props) => {
  const { PGVideoData } = props;

  return (
    <section className={styles['pg-video-box']}>
      <div className={styles['pg-video-title-box']}>
        <h2 className={styles['pg-video-title']}>{PGVideoData.title1}</h2>
        <span className={styles['comma-box']}>
          <Comma />
        </span>
        <h2 className={styles['pg-video-title']}>{PGVideoData.title2}</h2>
      </div>
      <div className={styles['pg-video-wrap']}>
        <VideoPlayer poster={PGVideoData.cover} showBigButton source={PGVideoData.videoLink} />
      </div>
    </section>
  );
};
PGVideo.defaultProps = {};

PGVideo.displayName = 'PGVideo';
export default PGVideo;
